<template>
    <div class="tv-tab" v-if="youTubeURL">
        <div v-if="videoText" class="tv-tab__text">
            <p v-html="videoText"></p>
        </div>
        <div class="tv-tab__video-container">
            <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="275" type="text/html"
                    :src="'https://www.youtube.com/embed/'+ youTubeURL +'?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0'">
            </iframe>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TvTab",
        inject: {
            itemId: {
                default: null
            }
        },

        computed: {
            currentItemVariation()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
            youTubeURL(){
                return this.findProperty(8);
            },
            videoText(){
                return this.findProperty(9);
            }
        },

        methods: {
            findProperty(propID)
            {
                if (this.currentItemVariation && typeof this.currentItemVariation.variationProperties != 'undefined' && this.currentItemVariation.variationProperties.length > 0)
                {
                    const props = this.currentItemVariation.variationProperties[0].properties;
                    const propData = props.find(p => p.id === propID);
                    if (propData && propData.values && propData.values.value)
                    {
                        return propData.values.value;
                    }
                }
                return "";
            }
        }
    };
</script>

